import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { ChartJsContainerComponent } from "@tylertech/chart-js";
import { ChartingModule } from "@tylertech/charting-module";
import { CoreModule } from "@tylertech/core-module";
import { CustomViewModule } from "@tylertech/custom-view";
import { BalanceByActivityChartComponent } from "./charts/balanceByActivityChart.component";
import { ExpenditureChartComponent } from "./charts/expenditureChart.component";
import { RevenueChartComponent } from "./charts/revenueChart.component";

const angularModules = [
    CommonModule,
    FlexModule,
    FlexLayoutModule,
];

const lgdModules = [
    CoreModule,
    ChartJsContainerComponent,
    ChartingModule,
    CustomViewModule
        .withComponents(
            /* eslint-disable @typescript-eslint/naming-convention */
            {
                "student-activities-balance-by-activity-chart": BalanceByActivityChartComponent,
                "student-activities-monthly-expenditure-chart": ExpenditureChartComponent,
                "student-activities-monthly-revenue-chart": RevenueChartComponent,
            }
            /* eslint-enable @typescript-eslint/naming-convention */
        ),
];

const components = [
    BalanceByActivityChartComponent,
    ExpenditureChartComponent,
    RevenueChartComponent
];
@NgModule({
    imports: [
        ...angularModules,
        ...lgdModules
    ],
    declarations: components,
    exports: components,
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StudentActivitiesModule { }
